export function youtubePreview() {
    const _document = this._document;
    this._window.addEventListener("load", () => {
        const players = _document.querySelectorAll(".rll-youtube-player");
    
        for(const player of players) {
            const imgSrc = player.querySelector("img").getAttribute("data-lazy-src");
            player.style.backgroundImage = `url('${imgSrc}')`;
        }
    });
}


// WEBPACK FOOTER //
// ./assets/js/modules/youtube-preview.js